"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react');

var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _typed = require('shared/hooks/typed');
var _inbox = require('shared/hooks/inbox');
var _requests = require('shared/selectors/requests');



/* Loads the caller's open requests when the inbox mounts, and again when an
 * org of theirs gains KEYWORDS. The socket listener reloads them on
 * reconnect and on each todos notification. Never asks without KEYWORDS. */
const useLoadOpenRequests = () => {
  const hasKeywords = _typed.useAppSelector.call(void 0, _requests.selectHasKeywordsOrg)
  _react.useEffect.call(void 0, () => {
    if (hasKeywords) _actions2.default.loadOpenRequests()
  }, [hasKeywords])
  return hasKeywords
}

const NO_REQUESTS_PILL = { count: 0, isSelected: false }









/* The inbox's Requests pill and the list it shows. The list is the open
 * requests' chats (this inbox's), newest request first; a chat leaves as soon
 * as its last request is handled. The server lists every request chat
 * whatever its archive state, so the pill counts the same chats and shows
 * only in the active view. */
 const useRequestsTab = ({ teamKey, activeTab, isArchived, listedKeys }) => {
  const hasKeywords = useLoadOpenRequests()
  const requestChatKeys = _typed.useAppSelector.call(void 0, state => _requests.selectOpenRequestChatKeys.call(void 0, state, teamKey))
  const isRequestsTab = activeTab === _inbox.InboxTab.REQUESTS
  const blobjectKeys = _react.useMemo.call(void 0, () => {
    if (!isRequestsTab) return listedKeys
    const listed = new Set(listedKeys)
    return requestChatKeys.filter(k => listed.has(k))
  }, [isRequestsTab, listedKeys, requestChatKeys])
  const count = requestChatKeys.length
  const isShown = hasKeywords && !isArchived
  const requestsPill = _react.useMemo.call(void 0, 
    () => (isShown ? { count, isSelected: isRequestsTab } : NO_REQUESTS_PILL),
    [isShown, count, isRequestsTab],
  )
  return { blobjectKeys, requestsPill }
}; exports.useRequestsTab = useRequestsTab
